import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8">Refund Policy for Slyder</h1>
        <p className="text-gray-400 mb-8">Last Updated: January 30, 2026</p>

        <div className="space-y-6 text-gray-300">
          <p className="text-lg leading-relaxed">
            At Slyder, operated by Ethereal Labs Private Limited, we provide digital services and subscriptions. Please review our policy regarding payments and refunds below.
          </p>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">1. Finality of Purchases</h2>
            <p className="leading-relaxed mb-4">
              All purchases and subscriptions made on Slyder are final and non-refundable.
            </p>
            <p className="mb-2">As stated in our Terms and Conditions:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>We do not provide any refunds or credits, including for partially used subscription periods.</li>
              <li>When you make a purchase, you acknowledge and agree that you waive any statutory "cooling-off" period or right of withdrawal to the maximum extent permitted by law.</li>
              <li>Digital goods/virtual currency are considered 'used' immediately upon purchase or consumption and are not eligible for refunds.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">2. Legal Exceptions</h2>
            <p className="leading-relaxed">
              An exception will only be made if a refund is mandatorily required by applicable consumer law in your jurisdiction.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">3. Subscription Management</h2>
            <p className="mb-4">Because our subscriptions are handled through a direct payment integration and not the standard app store billing system:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>You cannot manage or cancel your subscription through the Google Play Store or Apple App Store subscription centers.</li>
              <li>All cancellations must be performed within the Slyder app or by contacting our support team directly.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-white">4. Technical Support and Billing Inquiries</h2>
            <p className="leading-relaxed mb-4">
              If you are experiencing technical difficulties with your subscription or have a specific question regarding a transaction, please contact us for assistance.
            </p>
            <div className="space-y-2">
              <p className="font-semibold text-white">Contact Information:</p>
              <p><strong>Email:</strong> <a href="mailto:admin@slyderapp.com" className="text-purple-400 hover:text-purple-300 transition-colors">admin@slyderapp.com</a></p>
              <p><strong>Company:</strong> Ethereal Labs Private Limited</p>
              <p><strong>Address:</strong> F.No.205, 8-2-644/1/205, D'Desks, Hiline Complex, Road No.12, Banjara Hills, Hyderabad, Telangana, 500034.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
